<template>
  <p>privacy details</p>
</template>

<script>
export default {};
</script>

<style scoped>
</style>